// icon — default skin module
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    flex-shrink: 0;
    vertical-align: middle;
  }

  [part="base"] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--run-icon-size, var(--run-size-icon-md, 20px));
    height: var(--run-icon-size, var(--run-size-icon-md, 20px));
    color: var(--run-icon-color, currentColor);
    flex-shrink: 0;
  }

  :host([size="xs"]) [part="base"] {
    width: var(--run-icon-size, var(--run-size-icon-xs, 12px));
    height: var(--run-icon-size, var(--run-size-icon-xs, 12px));
  }
  :host([size="sm"]) [part="base"] {
    width: var(--run-icon-size, var(--run-size-icon-sm, 16px));
    height: var(--run-icon-size, var(--run-size-icon-sm, 16px));
  }
  :host([size="md"]) [part="base"] {
    width: var(--run-icon-size, var(--run-size-icon-md, 20px));
    height: var(--run-icon-size, var(--run-size-icon-md, 20px));
  }
  :host([size="lg"]) [part="base"] {
    width: var(--run-icon-size, var(--run-size-icon-lg, 24px));
    height: var(--run-icon-size, var(--run-size-icon-lg, 24px));
  }
  :host([size="xl"]) [part="base"] {
    width: var(--run-icon-size, var(--run-size-icon-xl, 32px));
    height: var(--run-icon-size, var(--run-size-icon-xl, 32px));
  }

  [part="base"] svg {
    width: 100%;
    height: 100%;
  }
`;

export function render(host) {
  const existing = host.shadowRoot.querySelector('[part="base"]');
  const svg = _buildSvg(host.name);
  if (existing) {
    existing.innerHTML = svg;
  } else {
    host.shadowRoot.innerHTML = `<span part="base">${svg}</span>`;
  }
}

function _buildSvg(name) {
  return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="3" ry="3" fill="currentColor" fill-opacity="0.12" stroke="currentColor"/>
    <text x="12" y="16" text-anchor="middle" font-size="8" fill="currentColor" stroke="none" font-family="system-ui, sans-serif" font-weight="500">${_abbrev(name)}</text>
  </svg>`;
}

function _abbrev(name) {
  if (!name) return '?';
  const parts = name.replace(/-/g, ' ').trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 3).toUpperCase();
  return parts.slice(0, 2).map(p => p[0].toUpperCase()).join('');
}
